export default __webpack_public_path__ + "static/verificador-repotenciador-17d730a4dbf17a309098caaa6b9fc46d.pdf";